import { useQuery, UseQueryOptions } from "react-query";
import { ITranslation, Route } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { axios } from "utilities/axios";
import { ITranslationParameters } from "@edgetier/watchtower-types/src";

/**
 * Request the translation from API
 */
export const requestTranslation = async (url: string, queryParameters: ITranslationParameters) => {
    const { data } = await axios.get(url, { params: queryParameters });
    return data;
};

/**
 * Hook used for text translation
 */
const useTranslation = <T = ITranslation>(
    queryParameters: ITranslationParameters,
    options: Omit<UseQueryOptions<ITranslation, AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.Translations;
    return useQuery<ITranslation, AxiosError, T>(
        [url, queryParameters],
        () => requestTranslation(url, queryParameters),
        options
    );
};

export default useTranslation;
